import React from 'react';
import { Switch, Text, theme, SwitchProps } from 'components';
import styled from 'styled-components';

interface LabelledSwitchProps extends SwitchProps {
  labelText: string;
}

const LabelledSwitch = ({ labelText, ...rest }: LabelledSwitchProps) => (
    <SwitchContainer>
      <Switch {...rest} />
      <StyledText>{labelText}</StyledText>
    </SwitchContainer>
  );

export default LabelledSwitch;

const SwitchContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
`;
const StyledText = styled(Text)`
  font-size: 14px;
  color: ${theme.gray10};
`;
